<ngx-spinner type="square-jelly-box">
  <h3>Loading...</h3>
</ngx-spinner>

@if (themeReady) {
  <div class="page-wrap" [lxResponsiveClass]="{ horizontal: 'page-wrap-desktop', vertical: 'page-wrap-handset' }">
    @if (!this.offerError) {
    <div class="offers-wrapper">
      <div class="offers">
        <mat-card class="validation-card not-available-text">
          <h2>One More Step!</h2>
          <p>An email was sent to your inbox, please click "Confirm Request" located inside the email to complete your request.</p>
          <button
            class="button-offer-card resend-email-button"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            type="button"
            #cardButton>
            <span class="material-icons cart-icon">mark_email_read</span>
            <span class="cart-label">Resend Email</span>
          </button>
        </mat-card>
      </div>
    </div>
    }
  </div>
}
